<template>
    <div class="view view-challenge-requests">
        <HeaderChallengeRequests
            textH1="Meydan Okuma İstekleri"
            textDesc="Gelen istekleri cevapla." />
        <Preloader
            v-if="showPreloader"
            preloaderText="Yükleniyor..." />
        <CardEmptyStateChallengeRequests
            v-if="showEmptyState"
            textHeading="İstek Yok"
            textDesc="Bir rakibin henüz çıkmadı." />
        <CardChallengeRequestsRivalNumber
            v-if="showRivalNumber"
            :numRival="requestItems.length" />
        <div
            v-if="showRequestList"
            class="view-challenge-requests__request-list">
            <CardChallengeRequestItem
                v-for="requestItem in requestItems" :key="requestItem.id"
                :requestItem="requestItem"
                @acceptChallenge="acceptChallenge"
                @rejectChallenge="this.$store.state.envDev ? rejectChallenge(requestItem) : rejectChallengeApi(requestItem)" />
        </div>
        <ModalChallengeRequests
            v-if="showModal"
            @cancelAcceptance="cancelAcceptance" />

        <BtnChallenge
            @click="routeChallengeSelectUser" />
        <BtnPracticeModes
            @click="routePracticeModes" />
        <Navbar />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallengeRequests          from '@/components/HeaderChallengeRequests.vue';
    import Preloader                        from '@/components/Preloader.vue';
    import CardEmptyStateChallengeRequests  from '@/components/CardEmptyStateChallengeRequests.vue';
    import CardChallengeRequestsRivalNumber from '@/components/CardChallengeRequestsRivalNumber.vue';
    import CardChallengeRequestItem         from '@/components/CardChallengeRequestItem.vue';
    import ModalChallengeRequests           from '@/components/ModalChallengeRequests.vue';
    import BtnChallenge                     from '@/components/BtnChallenge.vue';
    import BtnPracticeModes                 from '@/components/BtnPracticeModes.vue';
    import Navbar                           from '@/components/Navbar.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallengeRequests,
            Preloader,
            CardEmptyStateChallengeRequests,
            CardChallengeRequestsRivalNumber,
            CardChallengeRequestItem,
            ModalChallengeRequests,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        data(){
            return {
                showPreloader: false,
                showModal: false,
                allowRequest: true,
            };
        },

        computed: {
            showEmptyState(){
                let requestItems = this.$store.state.response.challengeRequests.requestItems;
                if(this.showPreloader){
                    return false;
                }
                else if(requestItems.length === 0){
                    return true;
                }
                return false;
            },

            showRivalNumber(){
                let requestItems = this.$store.state.response.challengeRequests.requestItems;
                if(this.showPreloader){
                    return false;
                }
                else if(requestItems.length === 0){
                    return false;
                }
                return true;
            },

            showRequestList(){
                let requestItems = this.$store.state.response.challengeRequests.requestItems;
                if(this.showPreloader){
                    return false;
                }
                else if(requestItems.length === 0){
                    return false;
                }
                return true;
            },

            requestItems(){
                return this.$store.state.response.challengeRequests.requestItems;
            }
        },

        methods: {
            getChallengeRequests(){
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeRequestAll, {
                    method: 'GET',
                    credentials: 'include',
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(challengeRequests => {
                    this.$store.commit('setChallengeRequestsRequestItems', challengeRequests);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(typeof err === 'object' && err.code){
                        if(err.code === 'CHALLENGE_REQUEST_ALL_MODEL/REQUEST_ALL::INV_USER_SESSION'){
                            this.$foneturkError({
                                text: this.$t(`error.api.challengeRequestAll.${err.code}`),
                                didClose: () => {
                                    this.$router.push('/login');
                                }
                            });
                        }
                        return true;
                    }
                    this.$foneturkError({
                        text: this.$t('error.default')
                    });
                });
            },

            acceptChallenge(requestItem){
                this.$store.commit('setInputChallengeRequestsSelectedRequest', requestItem);
                this.showModal = true;
            },

            cancelAcceptance(){
                this.showModal = false;
                this.$store.commit('setInputChallengeRequestsSelectedRequest', {});
            },

            rejectChallenge(){

            },

            rejectChallengeApi(requestItem){
                if(this.allowRequest === false){
                    return false;
                }

                this.allowRequest = false;
                this.showPreloader = true;
                let requestBody = {
                    idChallenge: requestItem.id
                };

                fetch(this.$store.state.api.challengeReject, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `rejectionOptions=${JSON.stringify(requestBody)}`
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(rejectionData => {
                    if(rejectionData.result !== true){
                        this.$foneturkError({
                            text: this.$t(`error.default`)
                        });
                        return true;
                    }
                    this.allowRequest = true;
                    this.getChallengeRequests();
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_REJECT_MODEL/REJECT::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeReject.${err.code}`),
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                        return true;
                    }
                    this.$foneturkError({
                        text: this.$t(`error.default`)
                    });
                });
            },

            routeChallengeSelectUser(){
                this.$router.push('/challenge/select-user');
            },

            routePracticeModes(){
                this.$router.push('/practice-modes');
            }
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.challengeRequestAll)
                .then(async response => {
                    return response.json();
                })
                .then(requestItems => {
                    this.$store.commit('setChallengeRequestsRequestItems', requestItems);
                    this.showPreloader = false;
                });
            }
            else{
                this.getChallengeRequests();
            }
        },
    };
</script>

<style scoped src="@/css/views/view-challange-requests.css"></style>